import { useCallback } from 'react';
import { useTranslation } from '../../../i18n/LanguageContext';
import { isBlank, parseDate } from './insuranceUtils';

/**
 * Texts of Sigorta Yönetimi (`insurance.*`). `formatDate` shows a stored
 * 'YYYY-MM-DD' in the UI language; `formatMoney` the amounts in ₺. The
 * Excel file keeps its Turkish layout.
 */
const useInsuranceText = () => {
  const { t, language, locale } = useTranslation();
  const label = useCallback((key, vars) => t(`insurance.${key}`, vars), [t]);
  const formatDate = useCallback((value) => {
    if (isBlank(value)) return '';
    const date = parseDate(value);
    return date ? date.toLocaleDateString(locale, { day: '2-digit', month: '2-digit', year: 'numeric' }) : String(value);
  }, [locale]);
  const formatMoney = useCallback((value) => {
    if (isBlank(value)) return '';
    const number = parseFloat(value);
    if (Number.isNaN(number)) return String(value);
    return `${number.toLocaleString(locale, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ₺`;
  }, [locale]);
  return { t, language, locale, label, formatDate, formatMoney };
};

export default useInsuranceText;
